const CustomAutoCompleteStyles = {
  inputLabel: {
    color: "text.primary",
    fontSize: "14px",
    flexShrink: 0,
    fontWeight: 600,
    textAlign:"start"
  },
  autoComplete: {
    "&:hover": {
      backgroundColor: "common.white",
    },
    "& .MuiInputBase-input": {
      padding: "10px 8px",
      color: "text.secondary",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      borderBottomColor: "text.primary",
    },
    "& .MuiOutlinedInput-root": {
      border: "none !important",
      padding: "0.4375rem !important",
      height: "2.5rem",
      borderRadius: "0.5rem",
    },
  },
  textField: {
    "& .MuiOutlinedInput-input": {
      padding: "0.4375rem",
    },
    "& .MuiOutlinedInput-root": {
      border: "none !important",
      padding: "0.4375rem !important",
      height: "2.5rem",
      borderRadius: "0.5rem",
    },
    "& .MuiInputBase-input": {
      padding: "0.4375rem !important",
    },
    "& .MuiInput-underline:before": {
      // borderBottom: "none !important",
    },
    "& .MuiInput-underline:hover:before": {
      // borderBottom: "none !important",
    },
    "& .MuiInput-underline:after": {
      // borderBottom: "none !important",
    },
  },
} as const;

export default CustomAutoCompleteStyles;
